import type { TCustomerioUsedFeature } from 'lib/customerio-tracker/customerio-tracker.types'

export const NICHE_LIMIT = 20

export const NICHE_MIN_LIMIT = 2

export const INDUSTRY_TOPIC_PREFIX = 'industry_topic.'

export const NICHE_PREFIX = 'niche.'

// System context IDs recognized by the backend. `mostEngaged` is the default
// context and is sent as a regular contextId like any other system context.
export const SYSTEM_CONTEXT_IDS = {
  mostEngaged: 'b3c4d5e6-f7a8-4b9c-8d0e-1f2a3b4c5d6e',
  happeningNow: 'f46f536a-d52a-4f92-8ae7-7291a98f60d8',
  products: 'd4e5f6a7-b8c9-4d0e-9f1a-2b3c4d5e6f7a',
  launches: '8f1d2c3b-4a5e-4f67-9a8b-7c6d5e4f3a2b',
  trendingProducts: '9a2b3c4d-5e6f-47a8-9b0c-1d2e3f4a5b6c',
  painPoints: 'ab3c4d5e-6f7a-48b9-8c0d-2e3f4a5b6c7d',
  paidPartnership: 'bc4d5e6f-7a8b-49c0-8d1e-3f4a5b6c7d8e',
  promotionsDiscounts: 'cd5e6f7a-8b9c-40d1-8e2f-4a5b6c7d8e9f',
  sponsoredEvents: 'de6f7a8b-9c0d-41e2-8f3a-5b6c7d8e9f0a',
  campaignsAndPublicity: 'e5f6a7b8-c9d0-4e1f-a2b3-4c5d6e7f8a9b',
  eventsAndCommemorativeDates: 'f6a7b8c9-d0e1-4f2a-b3c4-5d6e7f8a9b0c',
  socialIssues: '0f5fc5e2-2354-4b7c-811a-08ce621df30d',
} as const

export const ENTITY_TYPE_TO_CUSTOMER_IO: Record<string, TCustomerioUsedFeature> = {
  brand_territory: 'brands',
  brand_group: 'brands',
  tag: 'tags',
  trending: 'briefing',
  topics: 'topics',
  topic: 'topics',
  global_topic: 'topics',
  theme: 'topics',
  segment: 'topics',
  subject: 'topics',
  entity_query: 'topics',
  entity: 'topics',
  industry_topic: 'category',
  subtopic: 'topics',
  saved_search: 'topics',
  niche: 'topics',
}
